import { useMutation } from "react-query";
import { MessagingApi } from "../../services";
export const useMessaging = () => {
    const messagingApi = MessagingApi.init();
    const { mutateAsync: subscribeUser } = useMutation("subscribeUser", (payload) => messagingApi.subscribeUser(payload));
    const { mutateAsync: unsubscribeUserFully } = useMutation("unsubscribeUserFully", () => messagingApi.unsubscribeFromEverything());
    const { mutateAsync: unsubscribeUser } = useMutation("unsubscribeUser", (unsubscribePayload) => messagingApi.unsubscribe(unsubscribePayload));
    return { subscribeUser, unsubscribeUserFully, unsubscribeUser };
};
//# sourceMappingURL=useMessaging.js.map